const STEPS = {
  addPhoneNumber: 'ADD_PHONE_NUMBER',
  verifySMSCode: 'VERIFY_SMS_CODE',
  verifyCode: 'VERIFY_CODE',
  verifyEmail: 'VERIFY_EMAIL',
  verifyEmailComplete: 'VERIFY_EMAIL_COMPLETE',
  resetEmailSent: 'RESET_EMAIL_SENT',
  passwordChangeComplete: 'PASSWORD_CHANGE_COMPLETE',
  reauthenticateComplete: 'REAUTHENTICATE_COMPLETE',
  RESET: null // Reset login view step
};

export default STEPS;
